export const QLFEDITOR_BUTTON_CLASSNAME = 'qlfeditor-button';
